import angular, { IScope, ITimeoutService } from 'angular';
import uiRouter, { StateService } from '@uirouter/angularjs';
import { ApiService } from '@b2b/common/services/api/types';
import { TODO } from '@b2b/types/core/utils';
import { RemoveAddressModalControllerModule } from '../../../../views/application/views/partners/create/controllers/RemoveAddressModalController';

AddressListDirective.$inject = [];

function AddressListDirective() {
  AddressListController.$inject = [
    '$scope',
    'ConfigService',
    '$timeout',
    '$uibModal',
    'ApiService',
    'GridStateFactory',
    'GridDefinitionFactory',
  ];

  function AddressListController(
    $scope: IScope & {
      addressList: TODO;
      organizationId: string;
      viewId: string;
      loadPreferences: boolean;
      hideCreate?: boolean;
      hideRemove?: string;
      listId?: string;
      addressId?: string;
    },
    ConfigService: TODO,
    $timeout: ITimeoutService,
    $uibModal: TODO,
    ApiService: ApiService,
    GridStateFactory: TODO,
    GridDefinitionFactory: TODO
  ) {
    const ctrl = {
      model: [],
      removeModal: {} as TODO,

      gridState: new GridStateFactory(),
      gridDefinition: new GridDefinitionFactory(),
      addressListGridName: 'addressList.grid' + $scope.organizationId + '-' + $scope.listId,
      selectedRows: {},

      optionsOverride: {
        data: 'addressList.model',
        appScopeProvider: {
          onDataGridPaginate: function (newPageNumber, newPageSize, sortField, sortDirection) {
            ctrl.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
          },
          onDataGridSortChange: function (grid, columns, page) {
            ctrl.onDataGridSortChange(grid, columns, page);
          },
          onDataGridSelectionChange: function (row, e) {
            ctrl.onDataGridSelectionChange(row, e);
          },
          onEditClick: function (item) {
            ctrl.edit(item);
          },
          onRemoveClick: function (item) {
            ctrl.remove(item);
          },
        },
        columnDefs: [
          {
            field: 'edit',
            displayName: 'Edit',
            onCellNavClick: function (row, col) {
              ctrl.optionsOverride.appScopeProvider.onEditClick(row.entity);
            },
            cellTemplate:
              '<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.onEditClick(row.entity)" role="link">Edit<span class="sr-only"> Address</span></a></div>',
            enableHiding: false,
            enableSorting: false,
            width: 60,
          },
          {
            field: 'streetAddress1',
            displayName: 'Address 1',
          },
          {
            field: 'streetAddress2',
            displayName: 'Address 2',
          },
          {
            field: 'city',
            displayName: 'City',
          },
          {
            field: 'state',
            displayName: 'State / Province',
          },
          {
            field: 'country',
            displayName: 'Country',
          },
          {
            field: 'zipCode',
            displayName: 'Zip / Postal Code',
          },
          {
            field: 'isPrimary',
            displayName: 'Primary',
            cellTemplate:
              '<div class="ui-grid-cell-contents"><span data-ng-show="row.entity.isPrimary">Yes</span><span data-ng-hide="row.entity.isPrimary">No</span></div>',
          },
          {
            field: 'remove',
            displayName: 'Remove',
            enableSorting: false,
            onCellNavClick: function (row, col) {
              ctrl.optionsOverride.appScopeProvider.onRemoveClick(row.entity);
            },
            cellTemplate:
              '<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.onRemoveClick(row.entity)" role="button">Remove<span class="sr-only">-Opens a Dialog</span></a></div>',
            enableHiding: false,
            visible: !$scope.hideRemove,
            width: 60,
          },
        ],
      },

      init: function () {
        $scope.$on('DataGrid::UserPreferencesLoaded', this.initData);

        this.gridDefinition.init(this.addressListGridName, this.optionsOverride, $scope.viewId, $scope.loadPreferences);
        $scope.$on('AddressList::Refresh', this.onAddressListRefresh);
      },

      initData: function () {
        const props = ctrl.gridDefinition.getGridState();
        ctrl.gridState.updateGridState(
          props.page,
          props.pageSize,
          props.sortField || 'id',
          props.sortDirection || 'desc'
        );

        if ($scope.addressId) {
          ctrl.getAddresses({ id: $scope.addressId });
        } else {
          ctrl.getAddresses();
        }
      },

      edit: function (address) {
        // Show modal for editing
        $scope.$emit('AddressList::Edit', { address: address });
      },

      create: function () {
        $scope.$emit('AddressList::Create');
      },

      remove: function (address) {
        ctrl.removeModal = $uibModal.open({
          templateUrl: 'views/application/views/partners/create/modals/RemoveAddressModal.tpl.html',
          size: 'md',
          controller: 'RemoveAddressModalController',
          resolve: {
            address: function () {
              return address;
            },
          },
        });

        ctrl.removeModal.result.then(
          function (address) {
            //add the secondaryContact
            ApiService.organizations.addresses
              .remove($.extend({ organizationId: $scope.organizationId }, address))
              .then(function (response) {
                ctrl.success.remove(response);
                const found = ctrl.findAddress(address.id);

                if (found) {
                  ctrl.model.splice(found.index, 1);
                  $timeout(function () {
                    $scope.$broadcast('DataGrid::ResizeGrid', {
                      name: ctrl.gridDefinition.options.gridName,
                      datasetLength: ctrl.model.length,
                    });
                  }, 0);
                }
              }, ctrl.error.remove);
          },
          function () {
            //do nothing
          }
        );
      },

      getAddresses: function (selectedAddress?: TODO) {
        ApiService.organizations.addresses
          .list($.extend({ organizationId: $scope.organizationId }, this.gridState.getGridState()))
          .then(function (response) {
            ctrl.success.getAddresses(response);
            // Select address after short next tick
            if (selectedAddress) {
              $timeout(function () {
                const found = ctrl.findAddress(selectedAddress.id);
                if (found) {
                  ctrl.gridDefinition.selectRows(ctrl.model[found.index]);
                  if (ctrl.gridDefinition.isAccessbilityEnabled) {
                    ctrl.gridDefinition.gridApi.selection.selectRow(ctrl.model[found.index]);
                  } else {
                    ctrl.gridDefinition.options.api.forEachNode(function (node) {
                      if (node.data.addressId + '' === selectedAddress.id) {
                        node.setSelected(true);
                        return true;
                      }
                    });
                  }
                }
              }, 10);
            }
          }, this.error.getAddresses);
      },

      findAddress: function (id) {
        let i, ii;
        let r: false | { address: TODO; index: number } = false;

        for (i = 0, ii = this.model.length; i < ii; i++) {
          if ('' + this.model[i].id === '' + id) {
            r = {
              address: this.model[i],
              index: i,
            };
            break;
          }
        }

        return r;
      },

      findPrimaryAddress: function () {
        let i, ii;

        let r: false | { address: TODO; index: number } = false;

        for (i = 0, ii = this.model.length; i < ii; i++) {
          if (this.model[i].isPrimary) {
            r = {
              address: this.model[i],
              index: i,
            };
            break;
          }
        }

        return r;
      },

      process: function (addresses) {
        let i, ii;

        for (i = 0, ii = addresses.length; i < ii; i++) {
          // Copy for downstream use
          addresses[i].addressId = addresses[i].id;
        }

        return addresses;
      },

      success: {
        remove: function (response) {
          // noop
        },
        getAddresses: function (response) {
          ctrl.model = ctrl.process(response.data.payload.list);
          ctrl.gridDefinition.isLoaded = true;

          // Using an event to reduce coupling between directive and view
          const found = ctrl.findPrimaryAddress();
          if (found) {
            $scope.$emit('AddressList::PrimaryAddress', found);
          }

          $timeout(function () {
            $scope.$broadcast('DataGrid::ResizeGrid', {
              name: ctrl.gridDefinition.options.gridName,
              datasetLength: ctrl.model.length,
              totalItems: response.data.payload.pagination.count,
            });
          }, 10);
        },
      },

      error: {
        remove: function (response) {
          console.error('Error removing address:', response);
        },
        getAddresses: function (response) {
          ctrl.gridDefinition.isLoaded = true;
        },
      },

      onDataGridSelectionChange: function (row, e) {
        let i,
          ii;

        if (row instanceof Array) {
          for (i = 0, ii = row.length; i < ii; i++) {
            ctrl.selectedRows[row[i].entity.id] = { selected: row[i].isSelected, data: row[i].entity };
          }
        } else {
          ctrl.selectedRows[row.entity.id] = { selected: row.isSelected, data: row.entity };
        }
        $scope.$emit('AddressList::Select', { address: row.entity, selected: row.isSelected });
      },

      onDataGridPaginate: function (newPage, pageSize, sortField, sortDirection) {
        ctrl.gridState.updateGridState(newPage, pageSize);
        if (sortField) {
          ctrl.gridState.updateGridState(null, null, sortField, null);
        }
        if (sortDirection) {
          ctrl.gridState.updateGridState(null, null, null, sortDirection);
        }
        // Autoselect if address exists
        if ($scope.addressId) {
          ctrl.getAddresses({ id: $scope.addressId });
        } else {
          ctrl.getAddresses();
        }
      },

      onDataGridSortChange: function (grid, columns, page) {
        const data = columns[0];
        if (data) {
          ctrl.gridState.updateGridState(page || null, null, data.field, data.sort.direction);
          ctrl.getAddresses();
        }
      },

      onAddressListRefresh: function (e, data) {
        // Autoselect if address is available
        if (data && data.address) {
          ctrl.getAddresses(data.address);
        } else {
          ctrl.getAddresses();
        }
      },
    };
    $scope.addressList = ctrl;

    ctrl.init();
  }

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/address/list/list.tpl.html',
    scope: {
      viewId: '@',
      loadPreferences: '@',
      hideCreate: '=?',
      hideRemove: '@',
      listId: '@',
      addressId: '@',
      organizationId: '@',
    },

    link: function ($scope, $element, $attrs) {
      // Modified after controller runs
    },

    controller: AddressListController,
  };
}

export const AddressListModule = angular
  .module('acme.common.directive.addressList', [
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.config',
    'acme.common.factory.gridState',
    'acme.common.factory.gridDefinition',
    'acme.view.application.dataGrid.controllers',
    RemoveAddressModalControllerModule,
  ])
  .directive('addressList', AddressListDirective).name;
